export default {
  accounts: 'Accounts',
  editAlias: 'Edit alias',
  alias: 'Alias',
  balances: 'End-of-day balances',
  account: 'Account',
  bankingDay: 'End of banking day',
  float: 'Float',
  postedAmount: 'Posted amount',
  blocked: 'Blocked',
  interestAccrued: 'Interest accrued',
  dayFrom: 'Day from',
  dayTo: 'Day to',
  loadMore: 'Load more',
  allLoaded: 'All balances are loaded',
  balance: 'Balance',
  amount: 'Amount',
  balancesHeader: 'Account balances after transaction posting',
  accountNumber: 'Account number',
  status: 'Status',
  noAccounts: 'No accounts found',
  currency: 'Currency',
};
